import React from 'react'
import { DatePicker } from '@material-ui/pickers'

export const FormDatePicker = (props) => {
  return (
    <DatePicker
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      inputVariant="outlined"
      fullWidth
      shouldDisableDate={props.shouldDisableDate}
      error={props.error}
      format="DD-MM-yyyy"
      minDate={props.minDate}
      maxDate={props.maxDate}
      label={props.label}
    />
  )
}